import { Global, withTheme } from '@emotion/react'

import style from './GlobalStyles.style'

function GlobalStyles({ theme }) {
    return <Global styles={{ ...style(theme) }} />
}

export default withTheme(GlobalStyles)
